import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDeviationSelection } from '../../../_hocs/withSelectedDeviations';
import AddDeviationsButton from '../../../_partials/AddDeviationsButton';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import ManageableDeviation from '../../../_partials/ManageableDeviation';
import ManageableSelectedItemsPanel from '../../../_partials/ManageableSelectedItemsPanel';
import { useCurrentTierDeviations } from '../../../_hocs/withCurrentTierDeviations';
import DeviationGrid from '../../DeviationGrid';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import TierSidebar from './TierSidebar';
import s from './TierDeviationManager.scss';

export interface Props {}

const TierDeviationManager: React.FC<Props> = props => {
  const { t } = useTranslation();
  const { selectionLimit } = useDeviationSelection();
  const {
    isInitialized,
    isFetching,
    fetchMoreTierDeviations,
    hasMore,
    deviations,
  } = useCurrentTierDeviations();

  const renderEmpty = () => (
    <div className={s['empty-state-container']}>
      {t('mediapopup.empty.tier')}
    </div>
  );

  const deviationRenderer = (deviation, index) => {
    return <ManageableDeviation index={index} deviation={deviation} />;
  };

  const renderContent = () => {
    return (
      <>
        {isInitialized &&
          (!deviations.length && !hasMore ? (
            renderEmpty()
          ) : (
            <DeviationGrid
              deviations={deviations}
              deviationRenderer={deviationRenderer}
            />
          ))}
        {(!isInitialized || isFetching) && (
          <LoadingIndicator coverMode={!isInitialized} view="daSymbol" />
        )}
      </>
    );
  };

  const fetchMoreTierDeviationsIfNeeded = () => {
    if (!hasMore || isFetching) {
      return;
    }
    fetchMoreTierDeviations();
  };

  return (
    <PopupInnerLayout
      headerExtrasRightZone={<AddDeviationsButton limit={selectionLimit} />}
      headerExtrasBottomZone={<ManageableSelectedItemsPanel />}
      scrollableContent={renderContent()}
      sideBarContent={<TierSidebar />}
      onScrolledToBottom={fetchMoreTierDeviationsIfNeeded}
      onNotScrollable={fetchMoreTierDeviationsIfNeeded}
    />
  );
};
TierDeviationManager.displayName = 'TierDeviationManager';

export default TierDeviationManager;
